/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { connect } from 'react-redux';
import { closeModal, switchModal, speak } from '../../actions';
import X from '../../assets/login/x.svg';

const Onboarding1 = (props) => {
  return (
    <div className="modal onboarding-background onboarding-1">
      <img onClick={props.closeModal} className="x-icon" src={X} alt="x" />
      <h2 className="onboarding-header">
        Check this out!
      </h2>
      <div className="onboarding-main-container">
        <div className="onboarding-body">
          <div>
            <div className="onboarding-circle">1</div>
          </div>
          <div>
            <h4 className={`${props.speechEnabled && 'bolded'} color`} onClick={props.speak}>Choosing the right survey</h4>
            <div className="onboarding-text-container">
              <p onClick={props.speak} className={`${props.speechEnabled && 'bolded'} color`}>
                MBE is comprised of 13 surveys*. Begin by choosing a survey from the menu below for an area that you feel is your greatest challenge currently or is most important to you.
                <br /><br />*At this time, the only survey that is available on this platform is <b>How I Approach My Work</b>.
              </p>
            </div>
          </div>
        </div>
        <div className="onboarding-nav">
          <p onClick={() => props.switchModal('OnboardingInitial')} className="skip">Back</p>
          <p onClick={() => props.switchModal('Onboarding2')} className="skip">Next</p>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => (
  {
    speechEnabled: state.speech.enabled,
  }
);

export default connect(mapStateToProps, { closeModal, switchModal, speak })(Onboarding1);
